import { MapPin } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useDepot } from "@/context/DepotContext";

const NONE = "__none__";

// Depot choice inside create/edit dialogs. By default it only appears for a company
// login in the "All depots" view; `always` shows it whenever the company has depots.
export const DepotPicker = ({ value, onChange, testId = "depot-picker", label = "Depot", always = false, noneLabel, hint }) => {
  const { needsPick, depots, isAdmin } = useDepot();
  if (!(always ? isAdmin && depots.length > 0 : needsPick)) return null;
  return (
    <div className="space-y-2">
      <Label>{label}{noneLabel ? "" : " *"}</Label>
      <Select value={value || (noneLabel ? NONE : "")} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
        <SelectTrigger data-testid={testId}><SelectValue placeholder="Choose a depot" /></SelectTrigger>
        <SelectContent>
          {noneLabel && <SelectItem value={NONE}>{noneLabel}</SelectItem>}
          {depots.map((d) => <SelectItem key={d.id} value={d.id} data-testid={`${testId}-option-${d.id}`}>{d.name}</SelectItem>)}
        </SelectContent>
      </Select>
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
};

// Small depot label on cards/rows, shown only in the combined "All depots" view.
export const DepotTag = ({ id, testId }) => {
  const { showDepotTags, nameOf } = useDepot();
  if (!showDepotTags || !id || !nameOf(id)) return null;
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1 rounded-full bg-primary/10 text-primary px-2 py-0.5 text-[11px] font-medium whitespace-nowrap">
      <MapPin className="w-3 h-3" /> {nameOf(id)}
    </span>
  );
};
